import { React, useEffect, useReducer, useState,  } from 'react';

import { Row, Col, Typography, Space, Table, Empty, message, Spin, Popover, Avatar, Card, Button, Modal, Form, Breadcrumb } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { InfoOutlined, PlusOutlined, EditOutlined, DeleteOutlined, QuestionCircleOutlined, HomeOutlined} from '@ant-design/icons';
import {   ADD_QUESTION, ADD_QUESTION_ERROR, ADD_QUESTION_SUCCESS, BATCH_DETAILS, BATCH_DETAILS_ERROR, BATCH_DETAILS_SUCCESS, DELETE_QUESTION, DELETE_QUESTION_ERROR, DELETE_QUESTION_SUCCESS, EDIT_BATCH, EDIT_BATCH_ERROR, EDIT_BATCH_SUCCESS, QUESTION_LIST, QUESTION_LIST_ERROR, QUESTION_LIST_SUCCESS} from './constants';
import axios from 'axios';
import questionreducer from './reducer';
import { useLocation, useNavigate } from 'react-router-dom';

import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useFormik } from 'formik';
import TextArea from 'antd/es/input/TextArea';

const { Title } = Typography;



export default function ShiftManagement() {


	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = { retrain_historydata:[], batch : [], questions : [], details: null, loading: false, error: false, modelDeploymentInfo:[]};
	const [data, dispatch] = useReducer(questionreducer, initalState);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const [openAddDrawer, setOpenAddDrawer] = useState(false);
	const [openEditDrawer, setOpenEditDrawer] = useState(false);
	const [showDeleteQuestionModal, setShowDeleteQuestionModal] = useState(false);
	
	
	const navigate = useNavigate();
	const [form] = Form.useForm();	
	
	const location = useLocation();
	const {id} = location.state;

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	// const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);


	const columns = [

		
		{
			title: `${langdata && langdata.Questions ? langdata.Questions:'Questions'}`,
			dataIndex: 'text',
			key: 'text',
			
		},
		{
			title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
			key: 'attachmentUrls',
			align:'center',
			render: () => (
						
		
				<>
					<Space style={{justifyContent:'center',display:'flex'}} size="middle">
						<a title={langdata && langdata.Edit ? langdata.Edit:'Edit'}  onClick={showEditDrawer}><EditOutlined/></a>
						<a title={langdata && langdata.Delete ? langdata.Delete :'Delete'} onClick={openDeleteQuestionModal}><DeleteOutlined /></a>
		
					</Space>
				</>
			)
		}
	
	];

	
	useEffect(() => {
		// if(featuresModule.retrainingHistoryEnabled == false) {
		// 	navigate('/dashboard');
		// }
		if(!authtoken){
			navigate('/');
		}
	
	},[authtoken]);

	useEffect(() => {
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 4019);

	}, []);
	
	useEffect(() => {
		loadQuestions();
	}, []);


	const loadQuestions = () => {


		dispatch({ type : QUESTION_LIST});
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/shiftquestions?shiftquestionbatchId=${id}&pipelineId=${pipelineId}&$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
		};
	
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({ type : QUESTION_LIST_SUCCESS, payload : response.data.data});
				}else {
					dispatch({ type : QUESTION_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : QUESTION_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
					});
				}
			});

	};
	

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{langdata && langdata.ThisModuleEnablesTheConfigurationAndManagementOfShiftBasedInspectionPatrollingQuestionsForUsers ? langdata.ThisModuleEnablesTheConfigurationAndManagementOfShiftBasedInspectionPatrollingQuestionsForUsers :'This module enables the configuration and management of shift-based inspection patrolling questions for users.'}</p>
		</Card>
	);


	const showAddDrawer = () => {

		setOpenAddDrawer(true);
	};

	const onCloseAddDrawer = () => {
		setOpenAddDrawer(false);
	};

	const showEditDrawer = () => {
		
		setOpenEditDrawer(true);
		
	};

	const openDeleteQuestionModal = () => {
		setShowDeleteQuestionModal(true);
	};

	const addQuestion = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  '',
	
		},
		onSubmit: (values) => {
	
					
			if (!values.name || values.name == null || values.name === '') {
				Modal.warning({ title: langdata && langdata.PleaseEnterTheQuestion ? langdata.PleaseEnterTheQuestion : 'Please enter the question.' });
				return false;
			}
	
			dispatch({type:ADD_QUESTION});
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/shiftquestions`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					text : values.name,
					pipelineId : parseInt(pipelineId),
					shiftquestionbatchId : id,
				}
			};
	
			axios
				.request(config)	
				.then((response) => {
						
	
					if (response.status === 200 || response.status === 201) {
	
		
						dispatch( { type: ADD_QUESTION_SUCCESS, payload: response.data.data });
	
						Modal.success({ title: `${langdata && langdata.AddedQuestionSuccessfully ? langdata.AddedQuestionSuccessfully :'Question added successfully'}` });
						loadQuestions();
						form.resetFields();
						addQuestion.resetForm();
						setOpenAddDrawer(false);
	
						
					}
				})
				.catch((error) => {
					console.log(error);
						
					dispatch({ type: ADD_QUESTION_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
	});


	const editQuestion = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  data?.details?.text || '',
			
		},
		onSubmit: (values) => {
	
		
			dispatch({type:EDIT_BATCH});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/shiftquestions/${data?.details?.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					text : values.name,
					
				}
			};
 
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200) {
						dispatch( { type: EDIT_BATCH_SUCCESS});
						Modal.success({ title: `${langdata && langdata.QuestionUpdatedSUccessfully ? langdata.QuestionUpdatedSUccessfully :'Question updated successfully.'}` });
						editQuestion.resetForm();
						form.resetFields();
						setOpenEditDrawer(false);
						loadQuestions();
					}
				})
				.catch((error) => {
					console.log(error);
						
					dispatch({ type: EDIT_BATCH_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
		
	});

	const loadQuestionDetails = ((record) => {
		
		dispatch( { type: BATCH_DETAILS });
			
		if (!record) {
			dispatch({ type: BATCH_DETAILS_ERROR });
		} else {
			dispatch({ type: BATCH_DETAILS_SUCCESS, payload: record });
		
		}
		
	});

	const handleModalCancel = () => {
		setOpenEditDrawer(false);

	};
	const closeDeleteQuestionModal = () => {
		setShowDeleteQuestionModal(false);
	};

	const deleteQuestion = () => {
		const id = parseInt(data?.details?.id);
			
		dispatch({ type: DELETE_QUESTION });
		
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/shiftquestions/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
		
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_QUESTION_SUCCESS});
					setShowDeleteQuestionModal(false);        
					loadQuestions();
				} else {
					dispatch({type:DELETE_QUESTION_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_QUESTION_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};
	


	return (
		<>
			<Content>
				
				
				<Row 
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
					

					<Col span={8}>
						<Row>

							<Space>
								<QuestionCircleOutlined style={{fontSize:'30px'}} />

							</Space>
							<Space>&nbsp;&nbsp;</Space>
					
							<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.Questions ? langdata.Questions:'Questions'}</Title>
						</Row>

					</Col>
					<Col span={16}>
						<Row justify="end">
							<Col>
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={showAddDrawer}><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
		
								<Space>&nbsp;&nbsp;</Space>
								<Space>
									<Typography>
										<Popover title={langdata && langdata.Questions ? langdata.Questions:'Questions'}  content={infoContent} trigger="click">
											<Avatar size="small"><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row 
					style={{
						marginLeft:'15px',
						marginTop: '10px',
						marginBottom: '10px'
					}}            
				>
					<Breadcrumb
						items={[
							{
								href: '/dashboard',
								title: <HomeOutlined />,
							},
							{
								title:  <a onClick={()=>{navigate(-1);}}>{langdata && langdata.ShiftManagement ? langdata.ShiftManagement :'ShiftManagement'}</a> 
							},
							{
								title: `${langdata && langdata.Questions ? langdata.Questions :'Questions'}`,
							},
						]}
					/>
				</Row>
				
				<Row span={24} style={{
					margin: '10px',
					paddingLeft: '10px',
					paddingRight: '10px',
					marginTop:'0px',
					background: '#FFFFFF',
					alignItems:'center'
				}}>
					<Col span={24}>
						{data?.questions?.length > 0 ?
							<Table 
								scroll={{
									x: 900,
								}}
								columns={columns} dataSource={data.questions} 
								onChange = { loadQuestions }
								
								
								onRow={(record) => {
									return {
										onClick: () => { 
											loadQuestionDetails(record);
										}
									};
								}} />
							:
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						}
					</Col>
				</Row>

				<Modal
					title={ langdata&&langdata.AddQuestion ? langdata.AddQuestion : 'Add Question' }
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={openAddDrawer}
					onOk={{onCloseAddDrawer}}
					onCancel={onCloseAddDrawer}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={onCloseAddDrawer}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addQuestion.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={addQuestion.handleSubmit} form={form} >
									
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="name" label={langdata&&langdata.Questions?langdata.Questions:'Questions'} rules={[{ required: true, message: langdata && langdata.PleaseEnterTheQuestion ? langdata.PleaseEnterTheQuestion : 'Please enter the question' }]} >
									<TextArea   autoSize={{ minRows: 1}} name="name" onChange={addQuestion.handleChange} placeholder={langdata&&langdata.PleaseEnterTheQuestion?langdata.PleaseEnterTheQuestion:'Please enter the question'} />
								</Form.Item>
							</Col>
						</Row>														
					</Form>
				</Modal>


				<Modal
					title={langdata && langdata.EditQuestion ? langdata.EditQuestion:'Edit Question'}
					width={800}	
					centered
					destroyOnClose={true}
					maskClosable={false}
					onOk={editQuestion.handleSubmit}
					onCancel={handleModalCancel}
					open={openEditDrawer}
					styles={{
						body: {
						},
					}}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={handleModalCancel}>
								{langdata && langdata.CANCEL ? langdata.CANCEL:'CANCEL'}
							</Button>
							<Button onClick={editQuestion.handleSubmit} type="primary">
								{langdata && langdata.SAVE ? langdata.SAVE:'SAVE'}
							</Button>
						</Space>
					]}
				>
					<Form onSubmit={editQuestion.handleSubmit} layout="vertical"
						form={form} 
					>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Question ? langdata.Question:'Question'} rules={[{ required: false, message: `${langdata && langdata.Name ? langdata.Name:'Name'}` }]}>
									<TextArea autoSize={{ minRows: 1}} name="name" value={editQuestion.values.name} onChange={editQuestion.handleChange} defaultValue={editQuestion.values.name}   />
								</Form.Item>
							</Col>
						</Row>
						
				
									
					</Form>
				</Modal>



				<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeleteQuestionModal} onOk={deleteQuestion} onCancel={closeDeleteQuestionModal}>
					<Row style={{
						marginTop: '10px',
						marginBottom: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={1}>
							<DeleteOutlined  style={{ fontSize: '14px'}}/>
						</Col>
						<Col span={23}> { langdata && langdata.AreYouSureYouWantToDeleteThisQuestion ? langdata.AreYouSureYouWantToDeleteThisQuestion : 'AreYouSureYouWantToDeleteThisQuestion' }</Col>
					</Row>
				</Modal>
											
			</Content>
			

			<Spin spinning={data.loading} fullscreen />
		</>
	);
}